import * as Api from '../API/API.js';

import Modal from "react-bootstrap/Modal";
import NewsItem from './NewsItem'
import poiimg from '../Images/ic_poi.png'
import ExitButton from './ExitButton'

function POIModal(props){

    const _displayNews = (news) => {
      console.log("display news");
      if(news.length > 0){
      return(
        news.map((item) => { 
            return(
              <NewsItem
                key={item.title}
                title={item.title}
                picture={item.picture}
                text={item.text}
                date={item.date}
              />
            )       
          })  )
        
        }
    }

    const handleClose = () => props.setVisibleModalType(4);


   /* const newstest = [{
      "title": "News title",
      "text": "Le radeau végétalisé est un dispositif flottant sur lequel sont installés des plantes hygrophiles qui développent un système racinaire important qui permet éventuellement de filtrer l'eau du canal sur lequel il est installé. Ainsi, on peut observer une fonction d'épuration de l'eau du canal concerné. Les canaux sont des ouvrages d'assainissement participant à la gestion des eaux pluviales à ciel ouvert : ils récoltent les eaux pluviales des espaces publics et des bâtiments du quartier et permettent de les acheminer vers le jardin d'eau. Ils assurent un amortissement de l'eau qui favorise la décantation des matières en suspension contenues dans les eaux pluviales.",
      "date": "2021-06-17T18:13:08.893Z",
      "picture": "uploads/poipics/radeau.jpg"
    },
    {
      "title": "News title 2",
      "text": "Le radeau végétalisé est un dispositif flottant sur lequel sont installés des plantes hygrophiles qui développent un système racinaire important qui permet éventuellement de filtrer l'eau du canal sur lequel il est installé. Ainsi, on peut observer une fonction d'épuration de l'eau du canal concerné. Les canaux sont des ouvrages d'assainissement participant à la gestion des eaux pluviales à ciel ouvert : ils récoltent les eaux pluviales des espaces publics et des bâtiments du quartier et permettent de les acheminer vers le jardin d'eau. Ils assurent un amortissement de l'eau qui favorise la décantation des matières en suspension contenues dans les eaux pluviales.",
      "date": "2021-06-17T18:13:08.893Z",
      "picture": "uploads/poipics/radeau2.jpg"
    }]*/
    return(
        <Modal show={props.visible} onHide={handleClose}
        size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
  <Modal.Header className="poiModalHeader text-center">
  <Modal.Title className="poiModalTitle w-100"><div className="row"><div className="col-md-1 col-2 col-sm-2"></div><div className="col-md-10 col-8 col-sm-8"><img className="modalicon" src={poiimg} alt="" ></img></div><div className="col-md-1 col-md-1 col-2 col-sm-2"><ExitButton closeFunc={handleClose}/></div></div></Modal.Title>
  </Modal.Header>

  <Modal.Body>
  <div className="row">

  <div className="col-md-4 col-12 col-sm-12 text-center photoCol"><img className="modalPhoto" src={Api.getImage(props.infos.picture)} alt="" ></img></div>
  <div className="col-md-8 col-12 col-sm-12 contentCol">
    
    <div className="poiName">{props.infos.name}</div>
    <div className="poiDesc">{props.infos.description}</div>
</div>


</div>
{props.infos.news && _displayNews(props.infos.news)}
    
  </Modal.Body>

  
</Modal>
    )
}

export default POIModal;